module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_kiruto-698de0c82243a309c51b197d0799f658.png";